<div class="sz-trend-bars">
  @for (bar of bars(); track $index) {
    <div class="sz-trend-bars__col" [class.sz-trend-bars__col--best]="bar.best">
      <div class="sz-trend-bars__bar-track">
        <div class="sz-trend-bars__bar" [style.height]="height(bar.value)"></div>
      </div>
      <span class="sz-trend-bars__label">{{ bar.label }}</span>
    </div>
  }
</div>
